// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about-menu[data-v-44341a6e]{display:flex;flex-direction:column;padding:0 30px}@media (min-width: 1024px){.about-menu[data-v-44341a6e]{min-width:700px;flex-direction:row}}.extended-block[data-v-44341a6e]{padding:30px 20px}.extended-block h6[data-v-44341a6e]{font-size:12px;font-weight:600;margin-bottom:20px;text-transform:uppercase;color:#9096a0}.user-block[data-v-44341a6e]{padding:30px 20px;background:#fffae9}\n", ""]);
// Exports
module.exports = exports;
